<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" id="area_create" @submit.prevent="handleSubmit(handleAddPersonInCharge)">
        <span style="margin-top: 15px; margin-bottom: 20px;; display: block">Chọn người xử lý để xử lý <span style="color: red; font-weight: bold">{{ getCountTicketSelected(listTicketSelected.length) }} ticket</span> đã chọn</span>
        <ValidationProvider vid="name" name="Người phụ trách" rules="required"
                            v-slot="{ errors,classes }">
          <el-select
              ref="userSelect"
              v-model="assigned_user_id"
              filterable size="large"
              remote class="w-100"
              clearable
              placeholder="Chọn người phụ trách"
              :remote-method="remoteMethodUser"
              :loading="loading">
            <el-option
                v-for="item in handlerOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                errors[0]
              }}
            </div>
          </div>
        </ValidationProvider>
        <div style="width: 100%; display: flex;justify-content: flex-end; gap: 5px; margin-top: 10px">
          <el-button @click="closeDialog">Đóng</el-button>
          <button style="background: #5E00B6; color: white; padding-left: 15px; padding-right: 15px; border-radius: 4px" type="submit">Gán ticket</button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {GET_USER_QLHV} from "../../../../core/services/store/user/users.module";
import {HANDLE_ASSIGN_TICKET} from "../../../../core/services/store/ticket/ticket.module";
import {FIND_USER_BY_KEYWORD} from "../../../../core/services/store/okrs/okr.module";

export default {
  name: 'AddPersonalHandleTicket',
  data() {
    return {
      assigned_user_id: null,
      loading: false,
      queryUser: '',
      handlerOptions: []
    }
  },
  props: {
    listTicketSelected: {
      type: Array,
      required: true,
      default: []
    }
  },
  mounted() {
    this.getListIdTicketSelected()
    this.getListQlhv()
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    getUsers() {
      const payload = {
        keyword: this.queryUser,
      }
      this.$store.dispatch(FIND_USER_BY_KEYWORD, payload).then(res => {
        if (!res.error) {
          this.handlerOptions = res.data.map(item => {
            return {
              id: item.id,
              name: `${item.id + 100000} - ${item.name} - ${item.department_name}`,
            }
          }) ?? []
        }
      })
    },
    remoteMethodUser(query) {
      if (query !== '') {
        this.queryUser = query
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.getUsers()
        }, 400);
      } else {
        this.teacherOptions = [];
      }
    },
    getListIdTicketSelected() {
      this.ticketSelectedList = this.listTicketSelected.map((item) => {
        return item.id
      })
    },
    getListQlhv() {
      this.$store.dispatch(GET_USER_QLHV, {department_id: 31}).then((data) => {
        this.qlhvAssignees = data.data;
      })
    },
    getCountTicketSelected(count) {
      if (count && count < 9) {
        return `0${count}`
      }
      return count
    },
    handleAddPersonInCharge() {
      const payload = {
        ticket_ids: this.ticketSelectedList,
        assignee_id: this.assigned_user_id
      }
      this.$store.dispatch(HANDLE_ASSIGN_TICKET, payload).then(res => {
        if (!res.error) {
          this.$message.success('Điều phối ticket thành công')
          this.$emit('getTicketList')
          this.$emit('workCoordinationSuccess')
          this.closeDialog()
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>

</style>
